import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {tap} from 'rxjs';
import {IAccessData} from 'src/app/interfaces/employee.interface';
import {EmployeeStatuses} from 'src/app/interfaces/roles.interace';
import {AccessManagementService} from 'src/app/services/access-management.service';
import {EmployeeService} from 'src/app/services/employee.service';
import {UserRoles, roles} from 'src/app/shared/utils/roles';

@UntilDestroy()
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  public employeeId!: number;
  public currentName: string = '';
  public isAbleToView = true;
  public isAdmin = false;
  public isSalaryExtendedAccess!: boolean;
  public isAccountantAccess = false;
  public isHRManager = false;
  public isBcoinAccess = false;
  public isHRDataAccess = false;
  public isRecruiterAccess = false;
  public isSalaryRecruiterAccess = false;
  public accessData!: IAccessData;

  constructor(
    private employeeService: EmployeeService,
    private route: ActivatedRoute,
    private router: Router,
    private access: AccessManagementService
  ) {}

  ngOnInit(): void {
    this.employeeId = +this.route.snapshot.params['id'];
    const statusOfEmployee = this.access.statusOfEmployee.value;

    if (statusOfEmployee && statusOfEmployee.employeeId === this.employeeId)
      this.setPermissionsStatus(statusOfEmployee.status);
    else
      this.employeeService
        .getEmployeeStatus(this.employeeId)
        .pipe(
          untilDestroyed(this),
          tap(status =>
            this.access.statusOfEmployee.next({
              employeeId: this.employeeId,
              status: status.name,
            })
          )
        )
        .subscribe(status => this.setPermissionsStatus(status.name));

    this.subscribeToNameChanges();
    this.getEmployeeFullname();
  }

  setPermissionsStatus(status: string) {
    const accessData = this.route.snapshot.data['accessData'] as IAccessData;
    const isPending = status === EmployeeStatuses.Pending;
    this.isSalaryRecruiterAccess =
      this.access.salaryRecruiterReadAccess(accessData) && isPending;
    this.isRecruiterAccess = this.access.isRecruiterAccess() && isPending;

    this.isSalaryExtendedAccess =
      this.access.checkPermissions([
        ...roles.CEO,
        ...roles.DELIVERY_DEPARTMENT,
        ...roles.LINE_MANAGEMENT,
        ...roles.ACCOUNTANT_DEPARTMENT,
      ]) && status !== EmployeeStatuses.Pending;

    this.isHRDataAccess = this.access.hasHRDataAccess(accessData);

    this.isAccountantAccess = this.access.checkPermissions(
      roles.ACCOUNTANT_DEPARTMENT
    );
    this.isAbleToView = !this.access.checkPermissions(
      roles.RECRUITMENT_DEPARTMENT
    );
    this.isAdmin = this.access.checkPermissions(roles.ADMIN);
    this.isHRManager = this.access.checkPermissions([UserRoles.hrManager]);

    this.isBcoinAccess = this.access.checkPermissions(roles.HR_DEPARTMENT);
  }

  subscribeToNameChanges() {
    this.employeeService.getEmployeeFullNameStream
      .pipe(untilDestroyed(this))
      .subscribe(fullname => {
        this.currentName = fullname!;
      });
  }

  getEmployeeFullname() {
    this.employeeService
      .getEmployeeFullname(this.employeeId)
      .pipe(untilDestroyed(this))
      .subscribe(response => (this.currentName = response));
  }

  navigateToEmployees() {
    this.router.navigate(['employee']);
  }
}
